import { ForwardRefRenderFunction, forwardRef } from "react";

// #region types
import { SalaryFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { DateInputProps, TextInputProps, ToggleProps } from "models/propTypes/wintFormPropsTypes";
import { ChildCreateFormProps } from "models/propTypes/wintSalaryPropTypes";
// #endregion

// #region components
import {
  DateInput,
  HorizontalFormField,
  TextInput,
  Toggle,
  useWintForm,
  VerticalFormField,
  WintForm,
} from "components/common/wintForms";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";
// #endregion

const ChildCreateForm: ForwardRefRenderFunction<FormHandles, ChildCreateFormProps> = (props, ref) => {
  const { defaultValues, validationSchema, handleSubmit, onFormValidationChange } = props;

  const { wintFormProps, connect } = useWintForm<SalaryFormTypes.ChildCreate>({
    formRef: ref,
    defaultValues,
    validationSchema,
    handleSubmit,
    onFormValidationChange,
  });

  return (
    <WintForm {...wintFormProps}>
      <VerticalFormField<TextInputProps>
        Component={TextInput}
        {...connect("name")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.ChildName)}
        maxLength={100}
      />
      <VerticalFormField<DateInputProps>
        Component={DateInput}
        {...connect("dateOfBirth")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.ChildDateOfBirth)}
      />
      <HorizontalFormField<ToggleProps>
        Component={Toggle}
        {...connect("soleCustody")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.ChildSoleCustody)}
        mainLabelGridSize={9}
        childGridSize={3}
      />
    </WintForm>
  );
};

export default forwardRef(ChildCreateForm);
